module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.getVariationTitle(),
      "withFooter": !_vm.disabledInputs(),
      "withBody": !_vm.disabledInputs(),
      "onClick": function (value) { return _vm.onClickVariation(value); },
      "defaultSelect": _vm.variation.selected,
      "useAcordion": true,
      "blockSelect": _vm.variation.status === 'sent' || _vm.variation.status === 'error' || _vm.variation.status === 'cannotSend'
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [(_vm.variation.match && _vm.variation.match === true) ? _c('span', {
    staticClass: "badge-match",
    class: _vm.badgeClass
  }, [_vm._v(_vm._s('Match'))]) : _vm._e(), _vm._v(" "), (_vm.variation.status && _vm.variation.status !== 'sending') ? _c('span', {
    staticClass: "badge",
    class: _vm.badgeClass,
    attrs: {
      "data-label": _vm.variation.message
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.variation.status).label))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('product-price', {
    attrs: {
      "input": _vm.variation.price,
      "block": _vm.disabledInputs(),
      "module": _vm.fromModule,
      "sku": _vm.variation.sku
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, [(!_vm.$slots['ean']) ? _c('form-group', {
    attrs: {
      "label": "EAN",
      "columns": 6,
      "error": _vm.getError('ean', _vm.variation.sku),
      "required": _vm.isRequiredField()
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.ean),
      expression: "variation.ean"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs() || _vm.disabledInput('ean')
    },
    domProps: {
      "value": (_vm.variation.ean)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "ean", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._t("ean"), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Redutor",
      "columns": 3,
      "error": _vm.getError('stock.reducer', _vm.variation.sku),
      "required": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.stock.reducer),
      expression: "variation.stock.reducer"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.variation.stock.reducer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation.stock, "reducer", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Peso",
      "columns": 3,
      "error": _vm.getError('weight', _vm.variation.sku),
      "required": true
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.weight),
      expression: "variation.weight"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs() || _vm.disabledInput('weight')
    },
    domProps: {
      "value": (_vm.variation.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "weight", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("g")])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "l-col-6@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Altura",
      "columns": 4,
      "error": _vm.getError('height', _vm.variation.sku),
      "required": true
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('###.##'),
      expression: "'###.##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.height),
      expression: "variation.height"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs() || _vm.disabledInput('height')
    },
    domProps: {
      "value": (_vm.variation.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "height", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("cm")])]), _vm._v(" "), (_vm.toModule.identifier === 'cnova') ? _c('span', [_c('small', [_vm._v("(entre 1 e 700 cm)")])]) : _vm._e()]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Largura",
      "columns": 4,
      "error": _vm.getError('width', _vm.variation.sku),
      "required": true
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('###.##'),
      expression: "'###.##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.width),
      expression: "variation.width"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs() || _vm.disabledInput('width')
    },
    domProps: {
      "value": (_vm.variation.width)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "width", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("cm")])]), _vm._v(" "), (_vm.toModule.identifier === 'cnova') ? _c('span', [_c('small', [_vm._v("(entre 1 e 700 cm)")])]) : _vm._e()]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Comprimento",
      "columns": 4,
      "error": _vm.getError('length', _vm.variation.sku),
      "required": true
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('###.##'),
      expression: "'###.##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.length),
      expression: "variation.length"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs() || _vm.disabledInput('length')
    },
    domProps: {
      "value": (_vm.variation.length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "length", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("cm")])]), _vm._v(" "), (_vm.toModule.identifier === 'cnova') ? _c('span', [_c('small', [_vm._v("(entre 1 e 700 cm)")])]) : _vm._e()])], 1)])]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('image-variation', {
    attrs: {
      "variation": _vm.variation
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c66cc7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shared/provide/Variation.vue
// module id = 2895
// module chunks = 0